<div class="explorer-container">
  <div class="cursor-pointer flex flex-row justify-between items-center hover:bg-base-content/80 hover:text-base-300 bg-[#ebebeb]"
    [class.bg-[#dbdbdb]]="!node.isFolder && nodeIsVisible()">
    <div class="flex flex-row items-center w-full" (click)="onNodeClick()">
      <ng-icon *ngIf="node.isFolder" class="self-center transition-transform duration-300 flex-none"
        name="heroChevronRight" [ngClass]="{ 'rotate-90': node.active }" />
      <ng-icon *ngIf="!node.isFolder" class="self-center flex-none" name="heroDocument" />
      <div class="grow truncate pr-4">{{ node.name }}</div>
    </div>
    <button (click)="op.toggle($event)" class="absolute right-2">
      <i class="pi pi-ellipsis-v cursor-pointer text-xs"></i>
    </button>
    <p-popover #op position="right" appendTo="body">
      <ng-template pTemplate="content">
        <div class="icons-container flex flex-row gap-3 p-2 bg-base-100 rounded-md right-0">
          <button (click)="deleteNode(node)">
            <i class="pi pi-trash"></i>
          </button>
          <button *ngIf="!node.isFolder" (click)="downloadFile(node)">
            <i class="pi pi-download"></i>
          </button>
          <button *ngIf="node.isFolder" (click)="newItemPath = node; createItem('folder')">
            <i class="pi pi-folder-open"></i>
          </button>
          <button *ngIf="node.isFolder" (click)="newItemPath = node; createItem('file')">
            <i class="pi pi-file-o"></i>
          </button>
          <button *ngIf="node.isFolder" (click)="uploadFile.toggle(node)">
            <i class="pi pi-file-arrow-up"></i>
          </button>
        </div>
      </ng-template>
    </p-popover>
  </div>
  <div [class.max-h-0]="!node.active" [class.max-h-screen]="node.active"
    class="overflow-hidden transition-max-height duration-300 ease-in-out nested-items">
    <div *ngIf="isCreatingNewItem()" class="new-input pl-4">
      <input #newItemInput (blur)="cancelNewItem()" type="text" [(ngModel)]="newItemName"
        (keydown)="handleKeyDown($event)" placeholder="Enter name..." />
    </div>
    <div *ngFor="let item of node.items" class="file-tree">
      <div class="ml-1">
        <explorer [node]="item" />
      </div>
    </div>
  </div>
</div>
<app-upload-file #uploadFile></app-upload-file>
